export class triviaQuestion {
    constructor(public question: string, public answers: string[], public difficult: number, public type: string) {}
}

export class completeQuestion {
    constructor(public question: string, public answer: string, public src: string, public startWith: number[], public type: string) {}
}